import { createAction, props } from '@ngrx/store';
import { SessionState } from '../api/responses/get-accesso-pay-session';
import { PaymentType } from '../application-bridge/application-bridge.models';

export enum SessionActionTypes {
  SetAuthorizing = '[Session] Set Authorizing',
  FetchSessionToken = '[Session] Fetch Session Token',
  SetSessionLoaded = '[Session] Set Session Loaded',
}

/**
 * Set the authorizing property.
 */
export const setAuthorizingAction = createAction(SessionActionTypes.SetAuthorizing, props<{ authorizing: boolean; paymentType?: PaymentType }>());

/**
 * Fetch session token.
 */
export const fetchSessionTokenAction = createAction(SessionActionTypes.FetchSessionToken, props<{ payload: string }>());

/**
 * Set session loaded.
 */
export const setSessionLoadedAction = createAction(SessionActionTypes.SetSessionLoaded, props<{ sessionType: SessionState }>());
